import { queryOptions } from '@tanstack/react-query';
import type { Pagination } from '@/common/pagination';
import { axios } from '@/lib/utils/axios';
import type { WorkPackage, WorkPackageStatus } from '../../common/work-package';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type WorkPackageListSuccessResponseType = {
	workPackages: WorkPackage[];
	total: number;
	limit: number;
	offset: number;
};

export type WorkPackageQueryParams = Pagination & {
	assetId: string;
	status?: WorkPackageStatus;
	/** Gross amount range in cents, bounds included. */
	minGrossAmount?: number;
	maxGrossAmount?: number;
	/** Allowlisted `field:asc|desc` pairs, see WORK_PACKAGE_SORT_FIELDS in the backend DTO. */
	sort?: string;
	/** Only deleted work packages (needs WORK_PACKAGES_DELETE) */
	deleted?: boolean;
};

async function getListWorkPackages(query: WorkPackageQueryParams): Promise<WorkPackageListSuccessResponseType | null> {
	const response = await axios.get(`${API_URLS.WORK_PACKAGES.INDEX}`, {
		params: query,
	});
	return getResponse<WorkPackageListSuccessResponseType>(response.data);
}

export function getListWorkPackagesOptions(query: WorkPackageQueryParams, enabled = true) {
	return queryOptions({
		queryKey: ['work-packages', 'list', query],
		queryFn: () => getListWorkPackages(query),
		enabled,
	});
}
